// DialogConfirm.jsx
import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const DialogDetail = ({
  title,
  subtitle,
  icon,
  confirmAction = () => {},
  cancelAction = () => {},
  confirmText = "",
  cancelText = "",
  cancelButtonClass = "w-full",
  confirmButtonClass = "w-full",
  content,
  onClose,
  containerClass = 'lg:w-fit w-[90%]' 
}) => {
  const [visible, setVisible] = React.useState(true);

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  return (
    <Dialog open={visible} onOpenChange={setVisible}>
      <DialogContent className={`!p-2 md:!p-6 text-center card ${containerClass}`}>
        <DialogHeader>
          {icon && (
            <div className="flex justify-center mb-4">
              {typeof icon === "string" ? (
                <img src={icon} alt="icon" className="w-12 h-12" />
              ) : (
                icon
              )}
            </div>
          )}
          <DialogTitle className="hidden"></DialogTitle>
          { title && <p className="text-lg font-semibold text-center !mt-0">{title}</p>}
          { subtitle && <p className="text-sm text-muted text-center font-normal !mt-0">{subtitle}</p>}
        </DialogHeader>
        <DialogDescription className={`${!!content ? "" : "hidden"}`}>{content}</DialogDescription>
       { cancelText || confirmText && <div className="flex gap-3 mt-6 justify-center">
          {cancelText && <Button
            className={cancelButtonClass}
            variant="dark"
            onClick={() => {
              handleClose();
              cancelAction();
            }}
          >
            {cancelText}
          </Button>}
          { confirmText && <Button
            className={confirmButtonClass}
            onClick={() => {
              handleClose();
              confirmAction();
            }}
          >
            {confirmText}
          </Button>}
        </div>}
      </DialogContent>
    </Dialog>
  );
};